var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row small-up-1 medium-up-2 large-up-3" },
    [
      _vm._l(_vm.storage_boxes, function(storage_box) {
        return _c(
          "article",
          { staticClass: "column text-center c-card-box-wrapper" },
          [
            _c("a", { staticClass: "c-card-box" }, [
              _c(
                "div",
                {
                  staticClass: "c-card-box-section",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.openProductPage(storage_box)
                    }
                  }
                },
                [
                  storage_box.single_file
                    ? _c("img", {
                        staticClass: "c-card-box-image",
                        attrs: {
                          src: _vm.changeImageSize(
                            storage_box.single_file.media_path,
                            455,
                            "600"
                          ),
                          alt: storage_box.single_file.media_title,
                          alt: "storage-box"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("header", { staticClass: "c-card-box-heading" }, [
                    _c("span", { staticClass: "u-color-black" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(storage_box.name) +
                          " (" +
                          _vm._s(storage_box.formatted_min_size) +
                          "-" +
                          _vm._s(storage_box.formatted_max_size) +
                          "m³)\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "u-bold u-color-secondary" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.translate("frontend.js.storage_box.price", {
                              price: storage_box.formatted_price
                            })
                          ) +
                          "\n                    "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-card-box-content" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(storage_box.description) +
                        "\n                "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("footer", { attrs: { classs: "c-card-box-footer" } }, [
                _c("div", { staticClass: "flex-container flex-dir-column" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-red",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.requestQuote(storage_box)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.translate("frontend.js.storage_box.rent_now")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button u-no-margin-top",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openQuoteReveal(storage_box)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.translate(
                            "frontend.js.storage_box.request_quotation"
                          )
                        )
                      )
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      }),
      _vm._v(" "),
      _vm.toggle_quote_reveal
        ? _c("quote-reveal", {
            attrs: { storage_box: _vm.clicked_storage_box },
            on: { closeQuoteReveal: _vm.closeQuoteReveal }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75c689de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c689de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/frontend/vue/global/storage-box.vue
// module id = 47
// module chunks = 3 5